import { defineMessages } from "@/i18n";
import en from "./en";

export const inputBarMessages = defineMessages("input-bar", en);
